const initialState = {
  id: null,
  email: null,
  userName: null,
  profile_pic: null,
};

const registerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "user/register":
      return {
        ...state,
        id: action.payload.id,
        email: action.payload.email,
        userName: action.payload.userName,
        profile_pic: action.payload.profile_pic,
      };
    default:
      return state;
  }
};

export default registerReducer;
